import { jsx } from 'react/jsx-runtime';
import { useMemo, useCallback } from 'react';
import { Modal } from '@circlefin/components';
import { events } from '../events.js';
import { useModalHistory } from '../useModalHistory/useModalHistory.js';

const ModalRouterProvider = ({ children, onCloseStart, onCloseEnd, onBack })=>{
    const { route, prevRoute, history, clear, back } = useModalHistory();
    const { disableBack, keepOpenOnPageRoute, ...props } = useMemo(()=>route?.options ?? prevRoute?.options ?? {}, [
        prevRoute?.options,
        route?.options
    ]);
    // On Close Start.
    // Triggered when a modal is dismissed without invoking modal.close().
    const handleCloseStart = useCallback((event)=>{
        void events.emit('onCloseStart', {
            event,
            context: 'onDismiss'
        });
        onCloseStart?.(event);
    }, [
        onCloseStart
    ]);
    // On Close End.
    // Triggered when a modal is dismissed without invoking modal.close().
    const handleCloseEnd = useCallback((event)=>{
        void events.emit('onCloseEnd', {
            event,
            context: 'onDismiss'
        });
        onCloseEnd?.();
        clear();
    }, [
        clear,
        onCloseEnd
    ]);
    // Triggered when user goes back.
    const handleBack = useCallback((event)=>{
        void events.emit('onBack', {
            event,
            context: 'onBack'
        });
        onBack?.();
        back();
    }, [
        back,
        onBack
    ]);
    return jsx(Modal, {
        disableBack: disableBack ?? history.length === 0,
        onBack: handleBack,
        onCloseEnd: handleCloseEnd,
        onCloseStart: handleCloseStart,
        open: !!route?.pathname,
        ...props,
        children: children
    });
};

export { ModalRouterProvider };
//# sourceMappingURL=Router.js.map
